import { Paper, Text } from '@mantine/core'

export function MentorAnalysis({ label, narrative }) {
  if (!narrative) return null

  return (
    <Paper
      p="lg"
      className="glass"
      style={{
        borderColor: 'rgba(0, 229, 255, 0.2)',
        background: 'rgba(0, 229, 255, 0.03)',
      }}
    >
      <Text size="xs" c="dimmed" ff="Orbitron, sans-serif" fw={600} tt="uppercase" lts={1} mb="sm">
        {label || 'COMPASS AI Analysis'}
      </Text>
      <Text size="sm" c="gray.4" lh={1.6}>{narrative}</Text>
    </Paper>
  )
}
